const getInteractionDisplayType = ({ interactionType, sourceCrmEmailId }) => {
  if (interactionType === 'Email') return sourceCrmEmailId ? 'Email campaign' : 'Email';
  // The stored value is the plural type name ('Events'), matching the filter/tag option it came
  // from, but a single interaction is only ever one event.
  if (interactionType === 'Events') return 'Event';
  return interactionType;
};

export default getInteractionDisplayType;
